/** Switch visual (iOS-like). El input real queda en el padre para a11y/tests. */
export function PermissionSwitch({ on }: { on: boolean }) {
  return (
    <span
      aria-hidden
      className={`relative inline-flex h-7 w-12 shrink-0 items-center rounded-full transition-colors ${
        on ? 'bg-teal-600' : 'bg-gray-300 dark:bg-gray-600'
      }`}
    >
      <span
        className={`absolute top-0.5 h-6 w-6 rounded-full bg-white shadow-sm transition-[left] ${
          on ? 'left-[1.375rem]' : 'left-0.5'
        }`}
      />
    </span>
  );
}
